// Lib
import React, { useMemo } from 'react';

// Components
import CountButton from '../../Button/CountButton';
import CountButtonLabel from '../../Labels/CountButtonLabel';

// Constants
import {
  MORE_THAN_IN_STOCK_MESSAGE,
  OVER_LIMIT_MESSAGE,
} from '../../../constants/products';
import useUI from '../../../hooks/useUI';
import useUser from '../../../hooks/useUser';

// Utils
import isMoreThanInStock from '../../../utils/isMoreThanInStock';
import isDigitalAsset from '../../../utils/isDigitalAsset';

// Styles
import { useStyles } from './CartProductQtyButtonsStyles';

const CartProductQtyButtons = ({
  product,
  onAdd,
  onRemove,
  onSetCount,
  count,
  detailsMode, // in products modal details
  className,
  disabledCountBtn = false,
  isOverLimit = false,
  shippingAddresses = 1,
}) => {
  const { isMobileMode, isTabletMode } = useUI();
  const { isKiteUser, userWithoutAllLimits, userWithoutQuantityLimit } =
    useUser();
  const { classes, cx } = useStyles({ detailsMode, isMobileMode });

  const errorLabel = useMemo(() => {
    if (isMoreThanInStock(product, count, shippingAddresses)) {
      return MORE_THAN_IN_STOCK_MESSAGE;
    } else if (
      isOverLimit &&
      !(userWithoutAllLimits || userWithoutQuantityLimit)
    ) {
      return OVER_LIMIT_MESSAGE;
    } else return null;
  }, [
    count,
    product,
    isOverLimit,
    shippingAddresses,
    userWithoutAllLimits,
    userWithoutQuantityLimit,
  ]);

  const labelVariant = useMemo(() => {
    let variant;

    if (detailsMode) {
      variant = isTabletMode ? 'textLg' : 'textSm';
    } else {
      variant = isMobileMode ? 'textXs' : 'textSm';
    }

    if (!isKiteUser) {
      variant += 'Semibold';
    }
    return variant;
  }, [detailsMode, isKiteUser, isMobileMode, isTabletMode]);

  if (isDigitalAsset(product)) {
    return null;
  }

  return (
    <div className={cx(classes.container, className)}>
      <CountButton
        product={product}
        count={count}
        onAdd={onAdd}
        onRemove={onRemove}
        onSetCount={onSetCount}
        error={!!errorLabel}
        limitValue={true}
        className={classes.countButton}
        disabled={disabledCountBtn}
      />
      {errorLabel &&
        (!detailsMode && isTabletMode && !isMobileMode ? (
          <div className={classes.qtyButtonLabelContainer}>
            <CountButtonLabel
              variant={labelVariant}
              className={classes.qtyButtonLabel}>
              {errorLabel}
            </CountButtonLabel>
          </div>
        ) : (
          <CountButtonLabel
            variant={labelVariant}
            className={classes.qtyButtonLabel}>
            {errorLabel}
          </CountButtonLabel>
        ))}
    </div>
  );
};

export default CartProductQtyButtons;
